/**
 * Date / establishment / status filters for the sessions stacked chart.
 */

import * as React from 'react';
import { KpiFilters } from '@/components/kpi/KpiFilters';
import type { ChartFilterVisibility } from '@/components/charts/chart-configs';
import type { DashboardStatsDateFilterState } from '@/utils/dashboard-stats-date-range-utils';

/** Props for {@link SessionsChartFilters}. */
interface SessionsChartFiltersProps {
  filters: DashboardStatsDateFilterState;
  onChange: (next: DashboardStatsDateFilterState) => void;
  visibility: ChartFilterVisibility;
  sessionStatuses: string[];
  onToggleStatus: (status: string) => void;
}

/** Sessions-chart filter bar (period, dates, establishment, status). */
export const SessionsChartFilters: React.FC<SessionsChartFiltersProps> = ({
  filters,
  onChange,
  visibility,
  sessionStatuses,
  onToggleStatus,
}) => (
  <div className="filter-groups-container mb-5">
    <KpiFilters
      filters={filters}
      onChange={onChange}
      showPeriodFilter={visibility.showPeriodFilter}
      showDateRangeFilter={visibility.showDateRangeFilter}
      showEstablishmentFilter={visibility.showEstablishmentFilter}
      showStatusFilter={visibility.showStatusFilter}
      sessionStatuses={sessionStatuses}
      onToggleStatus={onToggleStatus}
    />
  </div>
);
